import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 10.838V6.5a3.5 3.5 0 0 0-5.17-3.076A3.5 3.5 0 0 0 10 4.5v.838A3.5 3.5 0 0 0 5 8.5V19a11 11 0 1 0 22 0v-5a3.5 3.5 0 0 0-5-3.162M13.5 3A1.5 1.5 0 0 0 12 4.5V14a1 1 0 1 1-2 0V8.5a1.5 1.5 0 0 0-3 0V19a9 9 0 0 0 18 0v-5a1.5 1.5 0 1 0-3 0v2.5a1 1 0 0 1-1 1 4 4 0 0 0-4 4 1 1 0 1 1-2 0 6 6 0 0 1 5-5.916V6.5a1.5 1.5 0 1 0-3 0V13a1 1 0 1 1-2 0V4.5A1.5 1.5 0 0 0 13.5 3"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconHandPalm = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconHandPalm);
export default Memo;
